export default __webpack_public_path__ + "static/media/Йод_40л.4b7f4e28.jpg";